<div class="w-full max-w-7xl items-center">
  <section class="mb-8 flex lg:mb-0" aria-label="Reset password">
    <div
      class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:min-w-[576px] md:p-10"
    >
      <!-- Comcast Business Logo -->
      <div class="mb-8 flex md:justify-center">
        <a
          routerLink="/"
          class="inline-block"
          aria-label="Comcast Business — go to homepage"
        >
          <img
            src="assets/images/logos/CB_Logo_Color_RGB.svg"
            alt=""
            role="presentation"
            class="h-10 w-auto md:h-14"
          />
        </a>
      </div>

      @if (isLoading() && !displayForm()) {
        <div
          class="mx-auto mt-4 flex justify-center"
          role="status"
          aria-label="Verifying reset link, please wait"
        >
          <mat-spinner [diameter]="40" aria-hidden="true"></mat-spinner>
        </div>
      }

      @if (displayForm()) {
        <!-- Title -->
        <h2
          id="reset-password-heading"
          class="font-montserrat mt-4 text-lg font-bold text-black lg:text-2xl"
        >
          Reset Your Password
        </h2>

        <form
          [formGroup]="resetPasswordFormGroup"
          novalidate
          aria-labelledby="reset-password-heading"
          (ngSubmit)="submitResetPassword()"
        >
          <span
            class="font-lato mt-4 flex text-[13px] font-bold tracking-[0.5px] text-black lg:text-sm"
            aria-hidden="true"
          >
            Account
          </span>

          <div
            class="font-lato mb-4 flex text-base"
            aria-label="Account: {{ username() }}"
          >
            {{ username() }}
          </div>

          <label for="password" class="comcast-input-label">New password</label>
          <input
            id="password"
            type="password"
            placeholder="Enter your new password"
            required
            name="password"
            autocomplete="new-password"
            (input)="validatePassword($event)"
            formControlName="pw1"
            aria-describedby="pw1-requirements"
            [attr.aria-invalid]="
              resetPasswordFormGroup.controls.pw1.value.length > 0 &&
              !criteriaMet()
                ? 'true'
                : 'false'
            "
            class="comcast-input"
          />

          <div aria-live="polite" aria-atomic="false" id="pw1-requirements">
            @if (!criteriaMet()) {
              <ul
                class="font-lato mt-2 flex flex-wrap text-sm"
                aria-label="Password requirements"
              >
                @for (c of criteria; track c) {
                  <li
                    [ngClass]="{ 'opacity-50': !values[c].valid }"
                    class="flex basis-full list-none items-center lg:basis-1/2"
                    [attr.aria-label]="
                      values[c].label +
                      (values[c].valid ? ', met' : ', not yet met')
                    "
                  >
                    @if (values[c].valid) {
                      <span
                        class="material-icons text-[#1E8500]"
                        aria-hidden="true"
                        >done</span
                      >
                    } @else {
                      <span
                        class="material-icons text-[#D11314]"
                        aria-hidden="true"
                        >fiber_manual_record</span
                      >
                    }
                    <span aria-hidden="true">{{ values[c].label }}</span>
                  </li>
                }
              </ul>
            } @else {
              <div class="comcast-validation-success">
                <span class="material-icons" aria-hidden="true"
                  >check_circle_outline</span
                >
                Password meets all criteria.
              </div>
            }
          </div>

          <label for="reenterPw" class="comcast-input-label mt-4"
            >Confirm new password</label
          >
          <input
            id="reenterPw"
            type="password"
            placeholder="Re-enter your new password"
            required
            name="pw2"
            autocomplete="new-password"
            (input)="doPasswordsMatch()"
            formControlName="pw2"
            aria-describedby="pw2-feedback"
            [attr.aria-invalid]="
              pwMatchErrorMessage().length > 0 ? 'true' : 'false'
            "
            [ngClass]="{
              'comcast-input-invalid': pwMatchErrorMessage().length > 0,
            }"
            class="comcast-input"
          />

          <div aria-live="polite" id="pw2-feedback">
            @if (pwMatchErrorMessage().length > 0) {
              <span class="comcast-validation-error">
                {{ pwMatchErrorMessage() }}
              </span>
            } @else if (pwMatchSuccessMessage().length > 0) {
              <span class="comcast-validation-success">
                <span class="material-icons" aria-hidden="true"
                  >check_circle_outline</span
                >
                {{ pwMatchSuccessMessage() }}
              </span>
            }
          </div>

          @if (errorMessage() && !isLoading()) {
            <div class="comcast-validation-error" role="alert">
              {{ errorMessage() }}
            </div>
          }

          <div class="mt-6 flex">
            <button
              type="submit"
              [disabled]="!criteriaMet() || isLoading()"
              [attr.aria-busy]="isLoading()"
              class="btn-primary"
            >
              @if (isLoading()) {
                <span class="sr-only">Resetting password, please wait</span>
                <div class="flex min-w-12 justify-center" aria-hidden="true">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              } @else {
                Reset Password
              }
            </button>
          </div>
        </form>
      } @else if (!isLoading()) {
        <div
          class="font-lato mt-4 flex text-base lg:text-lg"
          role="alert"
          aria-live="assertive"
        >
          This link has expired. Click the button below to reset your password.
        </div>

        <div class="mt-6 flex">
          <a routerLink="/forgot-password" class="btn-primary">
            Go to Forgot Password
          </a>
        </div>
      }
    </div>
  </section>
</div>
